export const GradientConfig = {
  collapseMenu: false,
  layoutType: 'menu-light', // menu-dark, menu-light, dark
  headerBackColor: 'header-blue', // header-blue, header-red, header-purple, header-info, header-dark, header-orenge
};
